// import { menuList } from "@/config/menu"
import { getMenuList as getMenu } from "@/http/home"

const state = {
  menuList: []
}

const mutations = {
  SET_MENU: (state, menuList) => {
    state.menuList = menuList
  },
  RESET_MENU: (state) => {
    state.menuList = []
  }
}

const actions = {
  async getMenuList({ commit, state }) {
    if (state.menuList.length !== 0) {
      return state.menuList
    }

    // const { data } = await getMenu()
    // 后期替换成data
    // commit('SET_MENU', data)
    let data = [

    ]
    return data
  },
  resetMenuList({ commit, state }) {
    commit('RESET_MENU')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}